import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { getDownloadFileInfo } from '../../../utilities/selectors';

interface Props {
  downloads: any[];
}

function DownloadsList({ downloads }: Props) {
  return (
    <Wrapper>
      {downloads.map(download => {
        const { id, path, name } = getDownloadFileInfo(download);
        return (
          <DownloadRow key={id}>
            <DownloadLink href={path} target="_blank">
              <SvgIcon
                icon={IconType.inwork}
                title="Stiahnuť súbor"
                alt="Stiahnuť súbor"
                cursor={'pointer'}
                fill={'#CCCCCC'}
                marginRight={8}
              />
              {name}
            </DownloadLink>
          </DownloadRow>
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  border: 0;
  border-radius: ${rem(2)};
  max-width: ${rem(480)};
  width: 100%;
  padding: 0;
`;

const DownloadRow = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(24)};

  &:last-child {
    margin: 0;
  }
`;

const DownloadLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(22)};

  &:hover {
    text-decoration: underline;
  }
`;

export { DownloadsList };
